var map = {
	"./eight.png": 5981,
	"./five.png": 2851,
	"./four.png": 288,
	"./nine.png": 1792,
	"./one.png": 1015,
	"./seven.png": 6676,
	"./six.png": 5844,
	"./ten.png": 2824,
	"./three.png": 3325,
	"./two.png": 349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 991;